module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.currentFarm) ? _c('div', {
    staticClass: "farm-page",
    class: {
      shop: _vm.isShop
    },
    attrs: {
      "data-aos": "fade"
    }
  }, [_c('div', {
    staticClass: "farm-page__top"
  }, [_c('top')], 1), _c('div', {
    staticClass: "farm-page__hero"
  }, [_c('hero', {
    attrs: {
      "currentFarm": _vm.currentFarm,
      "dico": _vm.dico
    }
  })], 1), _c('div', {
    staticClass: "farm-page__content"
  }, [_c('div', {
    staticClass: "farm-page__line1"
  }, [_c('div', {
    staticClass: "farm-page__line1__col1"
  }, [_c('select-menu', {
    attrs: {
      "currentFarm": _vm.currentFarm,
      "dico": _vm.dico
    }
  })], 1), _c('div', {
    staticClass: "farm-page__line1__col2"
  }, [_c('infos', {
    attrs: {
      "currentFarm": _vm.currentFarm,
      "dico": _vm.dico
    }
  })], 1)]), _c('div', {
    staticClass: "farm-page__line2"
  }, [_c('slider', {
    attrs: {
      "currentFarm": _vm.currentFarm,
      "dico": _vm.dico
    }
  })], 1), _c('div', {
    staticClass: "farm-page__line3"
  }, [_c('additional-infos', {
    attrs: {
      "currentFarm": _vm.currentFarm
    }
  })], 1), _c('div', {
    staticClass: "farm-page__line4"
  }, [_c('div', {
    staticClass: "farm-page__line4__col"
  }, [_c('google-map', {
    attrs: {
      "currentFarm": _vm.currentFarm
    }
  })], 1), (_vm.currentFarm.lastIndicators[0]) ? _c('div', {
    staticClass: "farm-page__line4__col"
  }, [_c('timelaps', {
    attrs: {
      "currentFarm": _vm.currentFarm
    }
  })], 1) : _vm._e()])]), _c('div', {
    staticClass: "farm-page__line5"
  }, [_c('div', {
    staticClass: "farm-page__content"
  }, [_c('interview', {
    attrs: {
      "currentFarm": _vm.currentFarm,
      "dico": _vm.dico
    }
  })], 1)]), _c('div', {
    staticClass: "farm-page__line6"
  }, [_c('div', {
    staticClass: "farm-page__content"
  }, [_c('bottom', {
    attrs: {
      "currentFarm": _vm.currentFarm,
      "dico": _vm.dico
    }
  })], 1)])]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7152a540", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7152a540"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/farm/FarmPage.vue
// module id = 827
// module chunks = 0